export default "__VITE_ASSET__GPAhCz11__"